import { useState, useRef, useEffect } from "react";
import { Toast } from "primereact/toast";
import { IconField } from "primereact/iconfield";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import ModalAddClassifications from "./ModalAddClassifications";
import {
    getDataAll,
    deleteClassification,
    setDataNull,
} from "../../store/classifications/slice";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Paginator } from "primereact/paginator";
import ActionMenu2 from "../../components/ActionMenu2";
import ModelDelete from "../../components/ModalDelete";

export default function Classifications() {
    const toast = useRef(null);
    const dispatch = useDispatch();
    const [keyword, setKeyword] = useState("");
    const [dialogAddVisible, setDialogAddVisible] = useState(false);
    const [rows, setRows] = useState(10);
    const [first, setFirst] = useState(0);
    const [rowData, setRowData] = useState();
    const [dialogEditVisible, setDialogEditVisible] = useState(false);
    const [modalDelete, setModalDelete] = useState(false);
    const { loading, classificationData, insertData, deleteData } = useSelector(
        (state) => ({
            loading: state.Classifications.loading,
            classificationData: state.Classifications.classificationData,
            insertData: state.Classifications.insertData,
            deleteData: state.Classifications.deleteData,
        }),
        shallowEqual
    );

    useEffect(() => {
        dispatch(
            getDataAll({ page: first + 1, limit: rows, keyword: keyword })
        );
    }, [rows, first, keyword, insertData, deleteData]);

    useEffect(() => {
        if (deleteData) {
            toast.current?.show({
                severity: "success",
                summary: "Thành công",
                detail: "Xoá phân loại thành công",
                life: 3000,
            });
        }
        dispatch(setDataNull());
    }, [deleteData]);

    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
    };

    const handleEdit = (rowData) => {
        setRowData(rowData);
        setDialogAddVisible(true);
    };

    const handleDelete = (rowData) => {
        setModalDelete(true);
        setRowData(rowData);
    };
    const actionBodyTemplate = (rowData) => {
        return (
            <ActionMenu2
                onEdit={() => handleEdit(rowData)}
                onDelete={() => handleDelete(rowData)}
            />
        );
    };
    const acceptDelete = () => {
        if (rowData) {
            const id = rowData.id;

            if (id !== undefined) {
                dispatch(deleteClassification({ id }));
            }
            setModalDelete(false);
        }
    };
    return (
        <div className="flex flex-column h-full">
            <Toast ref={toast} />
            <div className="pb-3 flex gap-8">
                <Button
                    label="Thêm phân loại"
                    style={{ height: "35px", width: "200px" }}
                    onClick={() => setDialogAddVisible(true)}
                />
                <IconField className="search-item">
                    <InputText
                        value={keyword}
                        onChange={(e) => setKeyword(e.target.value)}
                        placeholder="Tìm kiếm"
                        className="w-full border-0"
                    />
                </IconField>
            </div>
            <div className="bg-white border-round-md shadow-1 p-3 h-full flex flex-column justify-content-between">
                <DataTable
                    value={classificationData?.data?.items}
                    emptyMessage="Không có dữ liệu"
                    loading={loading}
                    size="small"
                    scrollHeight="65vh"
                    scrollable
                    dataKey="id"
                    rowClassName="custom-row-class"
                >
                    <Column
                        header="STT"
                        body={(rowData, options) => (
                            <div className="text-center">
                                {first + options.rowIndex + 1}
                            </div>
                        )}
                        style={{ width: "1%", minWidth: "20px" }}
                        alignHeader={"center"}
                        align={"center"}
                    ></Column>
                    <Column
                        header="Tên phân loại"
                        field="name"
                        style={{ width: "5%", minWidth: "200px" }}
                    ></Column>
                    <Column
                        header="Tên phân loại"
                        field="name"
                        style={{ width: "5%", minWidth: "200px" }}
                        body={(rowData) => (
                            <div>
                                {rowData.type === "product"
                                    ? "Sản phẩm"
                                    : "Vật tư"}
                            </div>
                        )}
                    ></Column>
                    <Column
                        header="Ghi chú"
                        field="description"
                        style={{ width: "6%", minWidth: "100px" }}
                    ></Column>
                    <Column field="action" body={actionBodyTemplate}></Column>
                </DataTable>
                <div className="card">
                    <Paginator
                        first={first}
                        rows={rows}
                        totalRecords={classificationData?.data?.totalItems}
                        rowsPerPageOptions={[10, 20, 30, 100, 200, 500]}
                        onPageChange={onPageChange}
                    />
                </div>
            </div>
            <ModalAddClassifications
                visible={dialogAddVisible}
                onHide={() => {
                    setDialogAddVisible(false);
                    setRowData(null);
                }}
                toast={toast}
                rowData={rowData}
            />
            <ModelDelete
                visible={modalDelete}
                setVisible={setModalDelete}
                accept={acceptDelete}
                msg={
                    <div style={{ textAlign: "center" }}>
                        Bạn chắc chắn muốn xóa hạng mục này?
                        <br />
                        Các thông tin liên quan đến hạng mục này sẽ bị xóa.
                    </div>
                }
            />
        </div>
    );
}
